import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer ,SafeUrl} from '@angular/platform-browser';
import { AuthService } from 'app/auth/auth.service';



@Component({
  selector: 'app-print-otconsent',
  templateUrl: './print-otconsent.component.html',
  styleUrls: ['./print-otconsent.component.scss']
})
export class PrintOTConsentComponent implements OnInit {
  pdfSrc: Uint8Array | null = null;
  
  pageArray:any=[];
  public totalPages: number = 0;
  patientdata:any;
  branchMasterobj:any;
  site:any;
  doctors:any
  procedurename:any;
  visitDate:any;
  showspinner:false;
  constructor(public authService:AuthService,private http: HttpClient,private sanitizer: DomSanitizer
    // public emrservice:EMRService,public branchMatserService:BranchMatserService,
    // public dialogRef: MatDialogRef<PrintOTConsentComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    ) { 
     
      this.patientdata = JSON.parse(localStorage.getItem('pateintdetail'));
      this.branchMasterobj=JSON.parse(localStorage.getItem('branchMasterobj'));
      this.site =localStorage.getItem('site');
      this.doctors =localStorage.getItem('doctor');  
      this.procedurename=  localStorage.getItem('ProcedureName'); 
      this.visitDate = localStorage.getItem('visitDate'); 
      this.pageArray.push(1);
     const splidata =localStorage.getItem('pdfURL');
     if(splidata){
      const splitdat =splidata.split(/[:;,]+/);
      this.convertBase64ToUint8Array(splitdat[3]);
     }else{
      this.pdfSrc=null;
     }
   
    }
    
    convertBase64ToUint8Array(base64String: string): void {
      const binaryString = atob(base64String); // Decode Base64 string to binary string
      const length = binaryString.length;
      const byteArray = new Uint8Array(length);
      // Fill the Uint8Array with the binary data
      for (let i = 0; i < length; i++) {
        byteArray[i] = binaryString.charCodeAt(i); // Convert each character to its charCode
      }
      this.pdfSrc = byteArray;
    }
  
  ngOnInit(): void {
    //this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(localStorage.getItem('pdfURL'));
  
   //  this.getBranchDetail(this.authService.Loggeduser.branchid);
   window.onbeforeunload = () => {
    localStorage.removeItem('pateintdetail');
    localStorage.removeItem('branchMasterobj');
    localStorage.removeItem('site');
    localStorage.removeItem('doctor');
    localStorage.removeItem('ProcedureName');
    localStorage.removeItem('visitDate');
    return false;
  };
  }
  // getBranchDetail(id) {

  //   this.emrservice.branchmansterObj = {};
  //   this.branchMatserService.getBrachMasterItem(id).subscribe((x: any) => {
  //     this.emrservice.branchmansterObj = x[0];
  //     console.log(this.emrservice.branchmansterObj);
      
  //   })
  // }
  afterLoadComplete(pdf: any) {
    this.pageArray=[];
    this.totalPages = pdf.numPages;
    if(this.totalPages >0){
      for(var i=1;i<=this.totalPages;i++){
        this.pageArray.push(i);
      }
    }
  }
  
  // closedialog(){
  //  this.dialogRef.close();
  // }
 
}
